export default "__VITE_ASSET__BRlxvSe2__"